module.exports = __webpack_public_path__ + "img/cart_empty.dca62fdd.png";